<template>
  <div class="silent-login-container">
    <div class="loading">
      <div class="loading-text">正在跳转微信授权...</div>
    </div>
  </div>
</template>

<script>
/**
 * 微信静默授权 - 构建授权链接页面（URL 跳转方式）
 * 
 * 流程说明：
 * 1. 业务页面直接跳转到本页面：/wx-silent-login?from=业务页面URL&wx_app_id=xxx
 * 2. 本页面接收参数并构建微信授权链接
 * 3. 跳转到微信授权页面
 * 4. 微信授权完成后回调到 /wx-redirect
 * 5. /wx-redirect 页面将 code 带回业务页面
 * 
 * URL 参数：
 * @param {String} from - 业务页面的完整 URL（包含所有 query 参数）
 * @param {String} wx_app_id - 微信公众号 appid
 */
export default {
  name: 'WxSilentLogin',
  
  mounted() {
    this.buildWxAuthUrl();
  },
  
  methods: {
    /**
     * 构建微信授权链接并跳转
     */
    buildWxAuthUrl() {
      const { from, wx_app_id } = this.$route.query;
      
      // 参数校验
      if (!from) {
        console.error('[WxSilentLogin] 缺少 from 参数');
        this.showError('缺少来源页面参数');
        return;
      }
      
      if (!wx_app_id) {
        console.error('[WxSilentLogin] 缺少 wx_app_id 参数');
        this.showError('缺少微信公众号 appid');
        return;
      }
      const callbackUrl = `${window.location.protocol}//${window.location.host}/wx-redirect`;
      
      // 构建回调 URL 的参数
      const callbackParams = new URLSearchParams({
        from: from  // 完整的业务页面 URL（包含所有原始参数）
      });
      
      const redirect_uri = encodeURIComponent(`${callbackUrl}?${callbackParams.toString()}`);
      
      // 构建微信授权链接
      const wxAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wx_app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
      
      // 直接跳转到微信授权页面（立即跳转，不延迟）
      window.location.href = wxAuthUrl;
    },
    
    /**
     * 显示错误信息
     */
    showError(message) {
      alert(`授权失败: ${message}\n\n请刷新页面重试`);
    }
  }
}
</script>

<style scoped>
.silent-login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading {
  text-align: center;
  background: white;
  padding: 40px;
  border-radius: 12px;
}

.loading-icon {
  font-size: 48px;
  margin-bottom: 20px;
  animation: rotate 2s linear infinite;
}

.loading-text {
  font-size: 16px;
  color: #999;
}

</style>
